const checkForShopLink = (component) => {
  try {
    const regex = new RegExp(/\/\/(shop|calm)\.mindbodygreen\.com/)

    // process the object keys to check for shop links
    function processKeys(object) {
      // iterate through the object keys and check for shop links
      const hasShoplink = Object.keys(object).some((key) => {
        const element = object[key]
        if (!element) {
          return false
        }

        if (Array.isArray(element)) {
          // if it is an array, recursively check for shop links
          return element.some((obj) => processKeys(obj))
        } else if (typeof Object.keys(element)?.length > 0) {
          return processKeys(element)
        } else {
          return regex.test(element)
        }
      })

      return hasShoplink
    }

    return processKeys(component)
  } catch (error) {
    console.log(error)
    return false
  }
}

export default checkForShopLink
